<template>
  <div class="bg-white-900 rounded px-5 pt-6 pb-4 relative">
    <!-- scrollbar-thin scrollbar-thumb-grey-700 scrollbar-track-grey-400 -->
    <shortlist-header title="Rename shortlist" />
    <div class="mt-9 mb-8">
      <input
        class="
          text-base text-black-900
          rounded
          border border-grey-700
          p-3
          w-full
          focus:border-black-900
          outline-none
        "
        type="text"
        v-model="inputData"
        placeholder="Name for shortlist"
      />
    </div>
    <div>
      <base-button colorScheme="orange" class="ml-auto py-3 max-w-164 w-full">
        <span class="font-normal text-sm"> Save </span>
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/utils/Button.vue";
import ShortlistModalHeader from "@/components/utils/ShortlistModalHeader.vue";
export default {
  name: "RenameShortlist",
  components: {
    "base-button": BaseButton,
    "shortlist-header": ShortlistModalHeader,
  },
  data() {
    return {
      inputData: "Non Fiction",
    };
  },
};
</script>
